
	import {
		defineComponent,
		onMounted,
		reactive,
		ref,
	} from 'vue';
	import {
		SyncOutlined
	} from '@ant-design/icons-vue';
	import {
		// Modal,
		message
	} from 'ant-design-vue';
	import cityData from '@/assets/data/city.json';
	import inforeview from '@/service/inforeview'
	import updatePeopleIn from "./updatePeopleIn.vue";
	export default defineComponent({
		components: {
			SyncOutlined,
			updatePeopleIn
		},
		setup(props, context) {
			// 声明
			let activeKey = ref("0") //0普通评审 1仲裁评审
			let visible = ref(false)
			let tableLoading = ref(false);
			let searchName = ref("");
			const openUpdatePop = ref();
			let columns = [{
				title: '姓名',
				dataIndex: 'userName',
				key: 'userName',
				align: 'center',
			},{
				title: '手机号',
				dataIndex: 'tel',
				key: 'tel',
				align: 'center',
			},{
				title: '学段',
				dataIndex: 'studyPhase',
				key: 'studyPhase',
				align: 'center',
			}, {
				title: '学科',
				dataIndex: 'subject',
				key: 'subject',
				align: 'center',
			},{
				title: '单位',
				dataIndex: 'unit',
				key: 'unit',
				align: 'center',
			},{
				title: '所在区',
				dataIndex: 'district',
				key: 'district',
				align: 'center',
			},{
				title: '评审1',
				dataIndex: 'reviewer1Name',
				key: 'reviewer1Name',
				align: 'center',
			}, {
				title: '总分',
				dataIndex: 'reviewer1Score',
				key: 'reviewer1Score',
				align: 'center',
			},{
				title: '评审2',
				dataIndex: 'reviewer2Name',
				key: 'reviewer2Name',
				align: 'center',
			},{
				title: '总分',
				dataIndex: 'reviewer2Score',
				key: 'reviewer2Score',
				align: 'center',
			},{
				title: '操作',
				key: 'action',
				align: "center"
			}];
			let tableData = ref([]);
			let reviewPeople = reactive({})
			// 页面渲染时加载
			onMounted(() => {

			})
			// 打开
			const open = (e) => {
				reviewPeople={}
				reviewPeople= e
				queryTable()
				visible.value = true
			}
			// 获取信息
			const queryTable = () =>{
				let dataJSON = {
					schoolCode:reviewPeople.schoolCode,
					taskId:reviewPeople.taskId,
					userId:reviewPeople.userId,
					reviewerType:reviewPeople.reviewerType,
					searchValue:searchName.value
				}
				inforeview.queryEnroll(dataJSON).then(({
					data
				}) => {
					if (data.code == '0') {
						data.data.map(item => {
							cityData[0].children[0].children.map(item2 => {
								if (item2.value == item.district) {
									item.districtMap = "上海市/市辖区/" + item2.label
								}
							})
						})
						tableData.value = data.data
						console.log(data.data)
					} else {
						message.error(data.msg);
					}
				})
				
			}
			
			// 更换评审人员
			const updateDetails = (e) =>{
				openUpdatePop.value.open(e, e.taskId, e.taskName);
			}
			// 关闭弹窗
			const handleCancel  = ()=>{
				context.emit('refresh', 'ok');
			}
			
			return {
				activeKey,
				visible,
				open,
				tableLoading,
				columns,
				cityData,
				tableData,
				updateDetails,
				searchName,
				queryTable,
				openUpdatePop,
				reviewPeople,
				handleCancel 
			};
		},

	});
